import React from "react";
import styled from "styled-components";
import { NavLink } from "react-router-dom";
import Button from "../styles/Button";
import { FaDiscord, FaInstagram, FaYoutube, FaAngleDoubleRight } from "react-icons/fa";
import Logo from '../images/footer-logo.png'

const Footer = () => {
  return (
    <>
      <Wrapper>
        <section className="contact-short">
          <div className="grid grid-two-column">
            <div>
              <h3>Ready to get started?</h3>
              <h3>Talk to us today</h3>
            </div>

            <div>
              <Button className="btn hireme-btn">
                <NavLink to="/"> Get Started </NavLink>
              </Button>
            </div>
          </div>
        </section>
        {/* footer section */}

        <footer>
          <div className="container grid grid-four-column">
            <div className="footer-about">
              <img src={Logo} alt="my logo img" />

              <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. </p>
            </div>
            <div className="footer-subscribe">
              <h3>Subscribe to get important updates</h3>
              <form action="#">
                <input type="email" name="email" placeholder="YOUR E-MAIL" />

                <input type="submit" value="subscribe" />
              </form>
            </div>
            <div className="footer-social">
              <h3>Follow Us</h3>
              <div className="footer-social--icons">
                <div>
                  <FaDiscord className="icons" />
                </div>
                <div>
                  <FaInstagram className="icons" />
                </div>
                <div>
                  <a
                    href="https://www.youtube.com/channel/UCwfaAHy4zQUb2APNOGXUCCA"
                    target="_blank"
                    rel="noreferrer">
                    <FaYoutube className="icons" />
                  </a>
                </div>
              </div>
            </div>
            <div className="footer-contact">
              <h3>Quick Links</h3>
              <li><NavLink to="/" className="footer_link"><FaAngleDoubleRight /> Home</NavLink></li>
              <li><NavLink to="/about" className="footer_link"><FaAngleDoubleRight /> About</NavLink></li>
              <li><NavLink to="/products" className="footer_link"><FaAngleDoubleRight />  Products</NavLink></li>
              <li><NavLink to="/contact" className="footer_link"> <FaAngleDoubleRight /> Contact</NavLink></li>
            </div>
          </div>

          <div className="footer-bottom--section">
            <hr />
            <div className="container grid grid-two-column ">
              <p>
                @{new Date().getFullYear()} CartFo. All Rights Reserved
              </p>
              <div className="text-footer">
                <span>Privacy Policy &nbsp; |</span>
                <span> &nbsp; Terms & Conditions</span>
              </div>
            </div>
          </div>
        </footer>
      </Wrapper>
    </>
  );
};

const Wrapper = styled.section` 
  .iSIFGq {
    margin: 0;
  }
  .contact-short {
    max-width: 60vw;
    margin: auto;
    padding: 5rem 10rem;
    background-color: ${({ theme }) => theme.colors.bg};
    border-radius: 1rem;
    box-shadow: ${({ theme }) => theme.colors.shadowSupport};
    transform: translateY(50%);
    .grid div:last-child {
      justify-self: end;
      align-self: center;
    }
    
  }
  .btn.hireme-btn:hover{
    border: 0.2rem solid #fb641b;
    padding: 0.8rem 1.8rem;
    transition: none;
    a{
      color:#fb641b;
    }      
  } 
  footer {
    .container{
      gap: 5rem;
    }
      .footer-about img {
      margin-bottom: 2rem;
  } 
    padding: 12rem 0 2rem 0;
    background-color: #131a22;
    h3 {
      color: ${({ theme }) => theme.colors.hr};
      margin-bottom: 2.4rem;
    }
    p {
      color: ${({ theme }) => theme.colors.white};
    }
    span {
      color: ${({ theme }) => theme.colors.white};
    }
    }
      .footer_link {
      color: white;
      font-size: 1.4rem;
    }


    .footer-subscribe{
      form{        
        input[type="submit"] {
          max-width: initial;
          width:17.2rem !important;          
      }
      }
    }

    .footer-social--icons {
      display: flex;
      gap: 2rem;
      div {
        padding: 1rem;
        border-radius: 50%;
        border: 2px solid ${({ theme }) => theme.colors.white};
        .icons {
          color: ${({ theme }) => theme.colors.white};
          font-size: 2.4rem;
          position: relative;
          cursor: pointer;
        }
      }
    }
  }
  .footer-bottom--section {
    padding-top: 5rem;
    p{
      text-align:left;
    }
    hr {
      margin-bottom: 2rem;
      color: ${({ theme }) => theme.colors.hr};
      height: 0.1px;
    }
    
    .text-footer{
        text-align:right;
    }
  }
  @media (max-width: ${({ theme }) => theme.media.mobile}) {
    .contact-short {
      max-width: 80vw;
      margin: 4.8rem auto;
      transform: translateY(0%);
      text-align: center;
      .grid div:last-child {
        justify-self: center;
      }
    }
    footer {
      padding: 9rem 0 2rem 0;
    }

    .footer-subscribe{
      form{
        display:flex;
        justify-content:space-between;
        
        input[type="submit"] {
          margin-top: 0rem; 
          
      }
      }




    .footer-bottom--section {
      .grid{
        gap:0.2rem;
      }
      padding-top: 4.8rem;
      
      p{
        text-align:center;
      }
      .text-footer{
        text-align:center;
    }
    }
  }
`;

export default Footer;